import React from 'react';
import { useSupplierOrders } from '@ubeya/shared/hooks/account/useSupplierOrders';
import { OrdersTab as SharedOrdersTab } from '@ubeya/shared-web/components';

export const OrdersTab = ({ supplierId, onOpenOrderDetails }) => {
  const { data = [], isLoading } = useSupplierOrders(supplierId);

  return <SharedOrdersTab data={data} isLoading={isLoading} onOpenOrderDetails={onOpenOrderDetails} />;
};
